export default {
      id: "ic-close-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic-close-usage",
      toString: function () {
        return this.url;
      }
    }